/**
 * Create the store with dynamic reducers
 */
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
export function configureStore(rootReducer, initialState = {}, history) {
    const middlewares = [routerMiddleware(history)];
    const enhancers = [
        applyMiddleware(...middlewares)
    ];
    let enhancer;
    // Master and production environment will not use dev tools
    if ((process.env.REACT_APP_ENV !== 'production' && process.env.REACT_APP_ENV !== 'master') && typeof window === 'object') {
        enhancer = composeWithDevTools(...enhancers);
    }
    else {
        enhancer = compose(...enhancers);
    }
    return createStore(rootReducer, initialState, enhancer);
}
export function createSubReducer(initialState, reducers) {
    return function reducer(state = initialState, action) {
        for (let i = 0; i < reducers.length; i++) {
            if (reducers[i].type === action.type) {
                return reducers[i].reducer(state, action);
            }
        }
        return state;
    };
}
//# sourceMappingURL=index.js.map